import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSwitch } from './Switch.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonSwitch({ prefix }));
}
